import React from 'react';
import { TouchableOpacity as Button } from '../forms';
import { useT } from '../../utils/helper';
import { useAlert } from '../../contexs/alert-context';
import { useCartsMutations } from '../../api/hooks/vendor/carts/use-carts-mutations';
import { CheckSVG } from '../../../assets/svg';
import { tw } from '../../utils/tailwind';

export const SetOrdersDoneButton = () => {
  const t = useT('navigation');
  const alert = useAlert();

  // Mutations
  const { setAllDone } = useCartsMutations();

  const handleSetOrdersDone = () => {
    alert.confirm(t('markAsAllCompleted?')).then(confirmed => {
      if (confirmed) {
        setAllDone.mutateAsync();
      }
    });
  };

  return (
    <Button
      theme={'blue'}
      disabled={false}
      label={t('allDone')}
      extraStyle="flex-row py-2 rounded-lg gap-x-2"
      extraLabelStyle="text-base normal-case leading-normal"
      onPress={handleSetOrdersDone}>
      <CheckSVG style={tw`w-4 h-4`} stroke="white" strokeWidth={3} />
    </Button>
  );
};
